var _path, _circle, _path2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCoreStrength(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.9262 3.94413C14.9281 3.18445 16.0691 2.79743 17.3112 2.79743C20.7755 2.79743 23.3712 5.57986 23.3712 9.22599C23.3712 11.2071 22.5565 12.8648 21.1638 14.5124C19.7802 16.1492 17.8067 17.798 15.4587 19.7597L15.4434 19.7725C14.641 20.4428 13.7335 21.2011 12.7902 22.0099L13.9262 3.94413ZM13.9262 3.94413C13.1335 4.54518 12.5632 5.27978 12.1803 5.89136M13.9262 3.94413L12.1803 5.89136M12.1803 5.89136C11.7975 5.27976 11.2272 4.54518 10.4344 3.94413C9.43251 3.18445 8.29158 2.79743 7.04941 2.79743C3.5851 2.79743 0.989451 5.57986 0.989451 9.22599C0.989451 11.2071 1.80412 12.8648 3.19695 14.5125C4.5806 16.1493 6.55416 17.7982 8.90249 19.7601L8.91776 19.7729C9.71963 20.4428 10.6273 21.2012 11.5705 22.0098C11.5705 22.0098 11.5705 22.0099 11.5706 22.0099L11.73 21.824M12.1803 5.89136L12.7901 22.01L12.6306 21.824C12.5061 21.9309 12.3462 21.9897 12.1803 21.9897C12.0144 21.9897 11.8545 21.9309 11.73 21.824M11.73 21.824C10.7856 21.0143 9.8769 20.2551 9.0752 19.5853L9.07479 19.5849L11.73 21.824Z",
    fill: "url(#paint0_linear_1144_1240)",
    stroke: "url(#paint1_linear_1144_1240)",
    strokeWidth: 0.489848
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 18.7963,
    cy: 16.2076,
    r: 4.35211,
    fill: "url(#paint2_linear_1144_1240)",
    stroke: "#C9E7FF",
    strokeWidth: 0.247678
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.6953 16.5427L18.0607 17.9229C18.0816 17.9441 18.1164 17.9422 18.1348 17.9188L20.8641 14.4523",
    stroke: "#CCDAFC",
    strokeWidth: 0.544892,
    strokeLinecap: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1144_1240",
    x1: 4.61767,
    y1: 2.43334,
    x2: 23.433,
    y2: 17.8373,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1E136C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#204995"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1144_1240",
    x1: 4.61767,
    y1: 2.43334,
    x2: 23.433,
    y2: 17.8373,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1E136C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#204995"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1144_1240",
    x1: 18.7963,
    y1: 11.7317,
    x2: 18.7963,
    y2: 20.6836,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2ECC71"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1AAF59"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCoreStrength);
export default __webpack_public_path__ + "static/media/core-strength.cba9d8f07662b71661e76ba9718f814a.svg";
export { ForwardRef as ReactComponent };